type Params = {
	skip: boolean;
	isSuperRecruiterFlowEnabled: boolean;
	isShareSlideUpEnabled: boolean;
	isMobile: boolean;
};

/**
 * Single source of truth for sharing-goal-flow eligibility, shared by `useShouldShowSharingGoalFlow`
 * (client-side rendering) and `normalizePsfShareGoalUxExperiment` (server-side experiment treat/exposure
 * gating) so the two can't drift out of sync with each other.
 */
export function shouldShowSharingGoalFlow({
	skip,
	isSuperRecruiterFlowEnabled,
	isShareSlideUpEnabled,
	isMobile,
}: Params): boolean {
	return !skip && isSuperRecruiterFlowEnabled && isShareSlideUpEnabled && isMobile;
}
